import { TRootState, TPriceTypesState } from '../../types'
import { createSelector } from '@reduxjs/toolkit'
import { priceTypesAdapter } from './adapter'

const selectState = (state: TRootState): TPriceTypesState => state.priceTypes

const adapterSelectors = priceTypesAdapter.getSelectors(selectState)

const fetchStatus = createSelector(
    selectState,
    (state) => ({
        isFetching: state.isFetching,
        error: state.fetchError,
    })
)

export const selectors = {
    ...adapterSelectors,
    fetchStatus
}